import { LicenseInfo } from "@mui/x-license";
import { getEnvironmentConfig, getRuntimeConfig } from "./runtime.ts";

let isLicenseApplied = false;

type LicenseSource =
  | "build"
  | "runtime"
  | "environment"
  | "meta"
  | "unknown";

type LicenseResolution = {
  key?: string;
  source?: LicenseSource;
};

declare global {
  interface Window {
    __MUI_LICENSE_STATUS__?: {
      applied: boolean;
      source?: LicenseSource;
      timestamp?: string;
    };
  }
}

const resolveLicenseKey = (): LicenseResolution => {
  const buildKey = import.meta.env.VITE_MUI_LICENSE_KEY;
  const runtimeKey = getRuntimeConfig().muiLicenseKey;
  const environmentKey = getEnvironmentConfig().muiLicenseKey;
  const metaKey =
    typeof document !== "undefined"
      ? document.querySelector('meta[name="mui-license"]')?.getAttribute("content") || undefined
      : undefined;

  if (buildKey) return { key: buildKey, source: "build" };
  if (runtimeKey) return { key: runtimeKey, source: "runtime" };
  if (environmentKey) return { key: environmentKey, source: "environment" };
  if (metaKey) return { key: metaKey, source: "meta" };

  return { key: undefined, source: "unknown" };
};

export const applyMuiLicense = () => {
  if (isLicenseApplied) return;

  const { key: licenseKey, source } = resolveLicenseKey();

  if (!licenseKey) {
    console.warn(
      "[MUI X] License key missing. Set VITE_MUI_LICENSE_KEY (build) or muiLicenseKey (runtime) before the app loads to remove the watermark.",
    );
    return;
  }

  LicenseInfo.setLicenseKey(licenseKey);
  isLicenseApplied = true;

  if (typeof window !== "undefined") {
    window.__MUI_LICENSE_STATUS__ = {
      applied: true,
      source,
      timestamp: new Date().toISOString(),
    };
  }
};
